import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, Shield, CheckCircle, Award } from 'lucide-react';
import { businessInfo, certifications } from '../../data/mock';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-navy text-white">
      {/* Trust badges section */}
      <div className="border-b border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {certifications.map((cert) => (
              <div key={cert.id} className="flex items-center gap-4 justify-center md:justify-start">
                <div className="w-12 h-12 rounded-full bg-teal/20 flex items-center justify-center">
                  {cert.id === 1 && <Award className="text-amber" size={24} />}
                  {cert.id === 2 && <CheckCircle className="text-amber" size={24} />}
                  {cert.id === 3 && <Shield className="text-amber" size={24} />}
                </div>
                <div>
                  <p className="font-semibold text-white">{cert.name}</p>
                  <p className="text-sm text-slate-300">{cert.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Main footer */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="md:col-span-2">
            <img 
              src={businessInfo.logo} 
              alt={businessInfo.name} 
              className="h-20 w-auto mb-4"
            />
            <p className="text-slate-300 max-w-md leading-relaxed">
              Professional bookkeeping services for small businesses, freelancers, and entrepreneurs. 
              We bring clarity to your finances so you can focus on what you do best.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-semibold text-lg mb-4">Quick Links</h3>
            <ul className="space-y-3">
              <li><Link to="/services" className="text-slate-300 hover:text-amber transition-colors">Our Services</Link></li>
              <li><Link to="/about" className="text-slate-300 hover:text-amber transition-colors">About Us</Link></li>
              <li><Link to="/testimonials" className="text-slate-300 hover:text-amber transition-colors">Testimonials</Link></li>
              <li><Link to="/faq" className="text-slate-300 hover:text-amber transition-colors">FAQ</Link></li>
              <li><Link to="/contact" className="text-slate-300 hover:text-amber transition-colors">Contact</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-semibold text-lg mb-4">Get in Touch</h3>
            <ul className="space-y-3">
              <li>
                <a href={`tel:${businessInfo.phone}`} className="flex items-center gap-3 text-slate-300 hover:text-amber transition-colors">
                  <Phone size={18} />
                  <span>{businessInfo.phone}</span>
                </a>
              </li>
              <li>
                <a href={`mailto:${businessInfo.email}`} className="flex items-center gap-3 text-slate-300 hover:text-amber transition-colors">
                  <Mail size={18} />
                  <span>{businessInfo.email}</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-slate-400">
            <p>© {currentYear} {businessInfo.name}. All rights reserved.</p>
            <div className="flex gap-6">
              <Link to="/privacy" className="hover:text-amber transition-colors">Privacy Policy</Link>
              <Link to="/terms" className="hover:text-amber transition-colors">Terms of Service</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
